import { Box, Typography, Button } from '@mui/material';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

export default function RolledBackPanel({ fromVersion, toVersion, onRetry, onClose }) {
  return (
    <Box sx={{ textAlign: 'center', maxWidth: 440, mx: 'auto', py: 4 }}>
      <SettingsBackupRestoreIcon sx={{ fontSize: 56, color: 'warning.main', mb: 2 }} />
      <Typography variant="h6" gutterBottom>Update didn&apos;t take</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Your sensor is safe on the previous version (v{fromVersion}). You can try again.
      </Typography>
      <Button variant="contained" onClick={onRetry} sx={{ mr: 1 }}>Try again</Button>
      <Button variant="text" onClick={onClose}>Close</Button>
    </Box>
  );
}
